module.exports = __webpack_public_path__ + "static/media/pig-green.443ae089.webp";